<template>
  <div class="min-h-screen bg-background">
    <Header />
    <main class="relative">
      <Hero />
      <div class="section-transition">
        <Services />
      </div>
      <div class="section-transition">
        <TechStack />
      </div>
      <div class="section-transition">
        <About />
      </div>
      <div class="section-transition">
        <CaseStudies />
      </div>
      <div class="section-transition">
        <Contact />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import Header from '@/components/forza/Header.vue'
import Hero from '@/components/forza/Hero.vue'
import Services from '@/components/forza/Services.vue'
import TechStack from '@/components/forza/TechStack.vue'
import About from '@/components/forza/About.vue'
import CaseStudies from '@/components/forza/CaseStudies.vue'
import Contact from '@/components/forza/Contact.vue'
</script>